export default __webpack_public_path__ + "static/media/luggage.801208d4.png";